import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import {
  Typography,
  Box,
  useTheme,
  Skeleton,
  useMediaQuery,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import {
  IMAGE_BASE_PATH_DBRADC,
  ORGANIZATION_ID,
  SUB_ORGANIZATION_ID,
} from '../../Config/Config'
import { fetchData } from '../../Assets/API/apiservices'

// Styled components
const CarouselContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
}))

const CarouselImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: 'auto',
  objectFit: 'cover',
  transition: 'filter 0.5s ease-out',
  '&.blurred-image': {
    filter: 'blur(10px)',
  },
  [theme.breakpoints.up('xl')]: {
    height: '650px',
  },
  [theme.breakpoints.between('lg', 'xl')]: {
    height: '600px',
  },
  [theme.breakpoints.between('md', 'lg')]: {
    height: '500px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    height: '400px',
  },
  [theme.breakpoints.down('sm')]: {
    height: '350px',
  },
}))

const WelcomeBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  height: '500px',
  [theme.breakpoints.down('sm')]: {
    height: '350px',
    padding: theme.spacing(2),
  },
}))

const Header_Carousel = () => {
  const [bannersData, setBannersData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.down('md'))

  const settings = {
    dots: true,
    arrows: !isMobile, // Show arrows only on desktop
    autoplay: true,
    fade: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    dotsClass: 'slick-dots custom-dots',
  }

  useEffect(() => {
    const getData = async () => {
      try {
        const result = await fetchData(
          `banners?organization_id=${ORGANIZATION_ID}&sub_organization_id=${SUB_ORGANIZATION_ID}`
        )
        const apiBanners = result.rows.map((row) => ({
          id: row.id,
          src: IMAGE_BASE_PATH_DBRADC + row.image_url,
          isFromAPI: true,
        }))
        setBannersData([...apiBanners])
      } catch (err) {
        console.error('Error fetching banners:', err.message)
      } finally {
        setIsLoading(false)
      }
    }
    getData()
  }, [])

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={isMobile ? '350px' : '500px'}
        bgcolor={theme.palette.background.default}
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
        />
      </Box>
    )
  }

  if (!bannersData.length) {
    return (
      <WelcomeBox>
        <Typography
          variant={isMobile ? 'h5' : 'h4'}
          color="textSecondary"
          textAlign="center"
          sx={{
            fontWeight: 500,
            px: 2,
          }}
        >
          🎉 Welcome! Stay tuned for exciting updates! 🎉
        </Typography>
      </WelcomeBox>
    )
  }

  return (
    <CarouselContainer>
      <Slider {...settings}>
        {bannersData.map((banner) => (
          <Box key={banner.id} sx={{ outline: 'none' }}>
            <CarouselImage
              src={banner.src}
              className="blurred-image"
              alt={`banner-${banner.id}`}
              onLoad={(e) => e.target.classList.remove('blurred-image')}
            />
          </Box>
        ))}
      </Slider>
    </CarouselContainer>
  )
}

export default Header_Carousel
